import React from "react"
import {Button, Form} from "react-bootstrap";
import {putPost} from "../../api/api_post";

export default class SearchPost extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            searchId:''
        }

        this.handleChangeSearchId = this.handleChangeSearchId.bind(this)
        this.handleSearch = this.handleSearch.bind(this)
    }

    handleChangeSearchId(e) {
        this.setState({searchId: e.target.value})
    }

    handleSearch(e) {
        // console.log(e.target.value)
        this.props.searchFunction({id: e.target.value})
    }

    render() {
        return <>
            <p>
                <Form.Control placeholder="Id" value={this.state.searchId}
                              onChange={this.handleChangeSearchId} onBlur={this.handleSearch}/>
                {/*<Button variant="outline-secondary" type="submit" >*/}
                {/*    Search*/}
                {/*</Button>*/}
            </p>
        </>
    }
}